<template>
    <div class="pc-wrap">
        <CompHeader />
        <div class="wrap">
            <CompSide @scrollTop="scrollTop" />
            <div class="mian-box" ref="mainBox">
                <div class="main-cont">
                    <div class="main">
                        <CompDel v-if="isGetPromission && !showNav" message="您还没有发起项目" />
                        <template v-else-if="proInfo.id">
                            <CompNoAuthority v-if="!authority" :message="message" />
                            <CompDel v-else-if="ifDel" message="项目已删除" />
                            <CompDel v-else-if="ifOffline" message="项目已下线" />
                            <CompNoAuthority v-else-if="ifOpen" message="暂未开启" />
                            <router-view v-else />
                        </template>
                        <router-view v-else />
                    </div>
                    <CompFooter ref="Footer"/>
                    <CompFloating :show="show" @scrollTop="scrollTop"/>
                    <ComMessage></ComMessage>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CompHeader from './common/header'
import CompSide from './common/side'
import CompFooter from './common/footer'
import CompFloating from './common/floating'
import CompNoAuthority from "@@/common/noAnuthority.vue"; // 无权限
import CompDel from "@@/common/del.vue"; // 项目已删除
import ComMessage from './common/message.vue'

import { mapMenu } from '@/utils/mapMenu'

import { mapState } from 'vuex';
export default {
    components: {
        CompHeader,
        CompSide,
        CompFooter,
        CompFloating,
        CompNoAuthority,
        CompDel,
        ComMessage
    },
    data() {
        return {
            show: false,
            message: '',
            ifShow: sessionStorage.getItem('show') || false,
            ifDel: false, // 是否删除
            ifOffline: false, // 是否下线
            ifOpen: true, // 是否有菜单权限
            isWds: false, // 是否是微打赏
        }
    },
    computed: {
        ...mapState({
            authority: state => state.project.authority,
            proInfo: state => state.project.proInfo || {},
            pro_info: state => state.project.proInfo.info || {},
            pro_list: state => state.project.proList,
            first_pro_list: state => state.project.firstProList,
            isGetPromission: state => state.project.isGetPromission,
        }),
        pro_id() {
            return this.proInfo.id || ''
        },
        showNav() {
            return (this.pro_list && this.pro_list.length) || (this.first_pro_list && this.first_pro_list.length)
        }
    },
    mounted() {
        const mainBox = this.$refs.mainBox
        mainBox.addEventListener('scroll', this.styleFun)
    },
    watch: {
        '$route': {
            handler() {
                // 更新数据
                this.updateData()
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        styleFun(e) {
            let top = e.target.scrollTop
            if (top > 90) {
                this.show = true
            } else {
                this.show = false
            }
        },
        scrollTop() {
            const mainBox = this.$refs.mainBox
            mainBox.scrollTo(0, 0)
        },
        async updateData() {
            this.ifDel = this.pro_info.id && this.authority && this.pro_info.status_code == -4
            this.ifOffline = this.pro_info.id && this.authority && this.pro_info.status_code == 12
            this.isWds = this.pro_info.id && this.authority && this.pro_info.pro_class == '201'

            
            if (this.isGetPromission) {
                let pro_class = this.pro_info.pro_class
                let status_code = this.pro_info.status_code
                let menuAuthority = true
                let proMenu = this.$route.meta.promission ? this.$route.meta.promission.menuName : 'index'

                if (pro_class == '201') {
                    let promission = this.$route.meta.promission ? this.$route.meta.promission.wdsMenu : false
                    menuAuthority = promission ? promission : (mapMenu.wdsMenu[status_code] && mapMenu.wdsMenu[status_code].length ? mapMenu.wdsMenu[status_code].includes(proMenu) : true)
                } else {
                    menuAuthority = mapMenu.proMenu[status_code] && mapMenu.proMenu[status_code].length ? mapMenu.proMenu[status_code].includes(proMenu) : true
                }
                this.ifOpen = (this.pro_info.temp_id && this.pro_info.status_code == -3 && this.$route.path !== `/project_manage/index/temp/${this.pro_id}`) || (!menuAuthority && this.$route.path !== `/project_manage/index/${this.pro_id}`)
            } else {
                this.ifOpen = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.pc-wrap {
    min-width: 1080px;
    min-height: 600px;
    height: 100%;
    background: #F2F2F2;
    .wrap {
        display: flex;
        height: calc(100vh - 70px);
        min-height: 530px;
        .mian-box {
            flex: 1;
            overflow-y: scroll;
            position: relative;
            height: 100%;
            .main-cont {
                display: flex;
                flex-direction: column;
                min-height: 100%;
            }
            .main {
                flex: 1;
                min-width: 1080px;
                padding: 20px 20px 0 0;
                background: #F2F2F2;
                position: relative;
                min-height: 510px;
                display: flex;
                flex-direction: column;
                &>:first-child{
                    flex: 1;
                    min-height: 500px;
                }
            }
        }
    }
}
</style>